import React from "react";

// Editorial section heading: short title + signature bronze rule + muted intro.
export const SectionHeading = ({ title, description, align = "left", id, eyebrow }) => {
  return (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-3xl"} id={id}>
      <h2 className="text-[24px] leading-[1.3] sm:text-[28px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.4px" }}>
        {title}
      </h2>
      <div className={`bronze-rule mt-5 ${align === "center" ? "mx-auto" : ""}`} />
      {description && (
        <p className="mt-7 max-w-[62ch] text-[15px] leading-[1.85]" style={{ color: "var(--muted)" }}>
          {description}
        </p>
      )}
    </div>
  );
};
